document.addEventListener('DOMContentLoaded', function() {
  var menuBtn = document.getElementById('menuBtn');
  var mobileMenu = document.getElementById('mobileMenu');
  var overlay = document.getElementById('mobileOverlay');
  var closeBtn = document.getElementById('mobileClose');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function() { mobileMenu.classList.add('active'); if(overlay)overlay.classList.add('active'); });
    if (closeBtn) closeBtn.addEventListener('click', function() { mobileMenu.classList.remove('active'); if(overlay)overlay.classList.remove('active'); });
    if (overlay) overlay.addEventListener('click', function() { mobileMenu.classList.remove('active'); if(overlay)overlay.classList.remove('active'); });
  }
  var track = document.getElementById('heroTrack');
  if (track) {
    var slides = track.children;
    if (slides.length > 1) {
      var current = 0;
      var prev = document.getElementById('heroPrev');
      var next = document.getElementById('heroNext');
      var dots = document.getElementById('heroDots');
      function go(idx) { current = idx; track.style.transform = 'translateX(-' + (idx*100) + '%)'; if(dots) Array.from(dots.children).forEach(function(d,i){d.classList.toggle('active',i===idx);}); }
      if (prev) prev.addEventListener('click', function() { go((current-1+slides.length)%slides.length); });
      if (next) next.addEventListener('click', function() { go((current+1)%slides.length); });
      if (dots) Array.from(dots.children).forEach(function(d,i){d.addEventListener('click',function(){go(i);});});
      setInterval(function() { go((current+1)%slides.length); }, 5000);
    }
  }
  var bannerTrack = document.getElementById('bannerSlider');
  if (bannerTrack) { var bi = 0; setInterval(function() { bi = (bi+1)%3; bannerTrack.style.transform = 'translateX(-' + (bi*100) + '%)'; }, 4000); }
  try { var cartCount = document.querySelector('[data-cart-count]'); if(cartCount){ var c = parseInt(cartCount.textContent); if(c>0)cartCount.style.display='flex'; } } catch(e){}
});